export const audits = {
	navTitle: "Auditoria",
};
